import { Component, OnInit } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { StockModel } from 'src/app/models/stock.model';
import { StockItemModel } from 'src/app/models/stock-item.model';
import { ClientService } from 'src/app/services/client/client.service';
import { AppearanceService } from '../../services/appearance/appearance.service';

import { Constants } from 'src/app/constants/constants';

@Component({
  selector: 'app-modal-stock-order',
  templateUrl: './modal-stock-order.component.html',
  styleUrls: ['./modal-stock-order.component.scss'],
})
export class ModalStockOrderComponent implements OnInit {

  stockItems: Array<StockItemModel>;
  allStockItems: Array<StockItemModel>;
  originalStockItems: Array<StockItemModel>;
  selectedUser = null;
  selectionForPreset: boolean = false;

  constructor(public clientService: ClientService, private modalController: ModalController,
    public appearanceService: AppearanceService,) { }

  ngOnInit() {}


  ionViewWillEnter()
  {    
    var allStockItems = this.clientService.getAllStockItems();

    for (var i = 0; i < allStockItems.length; i++)
    {
      allStockItems[i].quantity = 0    
      
      if(this.originalStockItems)
      {
        for (var x = 0; x < this.originalStockItems.length; x++)
        {
          if(allStockItems[i].uid == this.originalStockItems[x].uid)
          {
            allStockItems[i].quantity = this.originalStockItems[x].quantity;
          }
        }
      }
    }



    this.stockItems = JSON.parse(JSON.stringify(allStockItems));
  }

  makeStockRequest()
  {
    var requested = new Array<StockItemModel>();

    for (var i = 0; i < this.stockItems.length; i++)
    {
      if (this.stockItems[i].quantity > 0)
      {
        requested.push(this.stockItems[i]);
      }
    }

    if (requested.length == 0)
    {
      this.appearanceService.presentToast("Please add at least one item.", Constants.TOAST_INFO);
      return;
    }

    if(!this.selectedUser)
    {
      this.appearanceService.presentToast("Select User.", Constants.TOAST_INFO);
      return;
    }

    var payload = {
      stockRequests: requested,
      clientUid: this.clientService.getClientUid(),
      organisationUid: this.clientService.getOrganisationUid(),
      userUid: this.selectedUser.uid
    }

    this.appearanceService.showLoading("Please wait...").then(() => {

      this.clientService.createNewStockOrder(payload).subscribe(response => {
    
        this.appearanceService.dismissLoading();

        if (response.Success)
        {
          var returnData = { orderCreated: true };
          this.closeModal(returnData);
          this.appearanceService.presentToast("Order Created.", Constants.TOAST_SUCCESS);
        }
        else
        {
            this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
        }
      },
      err => {

        this.appearanceService.dismissLoading();
        this.appearanceService.presentToast(err, Constants.TOAST_ERROR);

      });
    });
  }

  returnSelectedStock()
  {
    var requested = new Array<StockItemModel>();

    for (var i = 0; i < this.stockItems.length; i++)
    {
      if (this.stockItems[i].quantity > 0)
      {
        requested.push(this.stockItems[i]);
      }
    }

    if (requested.length == 0)
    {
      this.appearanceService.presentToast("Please add at least one item.", Constants.TOAST_INFO);
      return;
    }

    this.modalController.dismiss(requested, null, 'StockOrderModal');

  }

  increaseStockQuanity(choice)
  {    
    choice.quantity++;
  }


  decreaseStockQuantity(choice)
  {
    if (choice.quantity > 0)
    {
      choice.quantity--;
    }
  }

  closeModal(returnData = null)
  {
    this.modalController.dismiss(returnData, null, 'StockOrderModal');
  }
}
